import Service from "../../UI/_Srvice/Service";
import ButtonAdditionalQuestions from "./ButtonAdditionalQuestions";
import styles from "./List.module.css";

export default function List({
    setProcessIndex,
    setSelectedService,
    serviceTypes,
    serviceGroups,
    filteredServices,
    setInHelp,
    selectedAttributes,
}) {
    const onServiceClick = (service) => {
        setSelectedService(service);
        setProcessIndex("selected_service");
    };
    return (
        <>
            <div className={styles.container}>
                {filteredServices.length === 0 ? (
                    <div className={styles[`no-service-message`]}>
                        Trenutno nema dostupnih usluga na vašem području s
                        odabranom brzinom i filterima.
                    </div>
                ) : (
                    serviceTypes.map((type, typeKey) => {
                        return (
                            <div key={typeKey}>
                                {filteredServices.findIndex(
                                    (service) => service.service_type === type
                                ) > -1 ? (
                                    <>
                                        <div className={styles[`type-label`]}>
                                            {type}
                                        </div>
                                        <div>
                                            {serviceGroups.map(
                                                (group, groupKey) => {
                                                    return (
                                                        <div key={groupKey}>
                                                            {filteredServices.findIndex(
                                                                (el) =>
                                                                    el.service_group ===
                                                                        group &&
                                                                    el.service_type ===
                                                                        type
                                                            ) > -1 ? (
                                                                <>
                                                                    <div
                                                                        className={
                                                                            styles[
                                                                                `group-label`
                                                                            ]
                                                                        }
                                                                    >
                                                                        {group}
                                                                    </div>
                                                                    <div
                                                                        className={
                                                                            styles[
                                                                                `service-list`
                                                                            ]
                                                                        }
                                                                    >
                                                                        {filteredServices.map(
                                                                            (
                                                                                service
                                                                            ) => {
                                                                                if (
                                                                                    service.service_group ===
                                                                                        group &&
                                                                                    service.service_type ===
                                                                                        type
                                                                                ) {
                                                                                    return (
                                                                                        <Service
                                                                                            key={
                                                                                                service.id
                                                                                            }
                                                                                            service={
                                                                                                service
                                                                                            }
                                                                                            action={
                                                                                                true
                                                                                            }
                                                                                            onClick={() =>
                                                                                                onServiceClick(
                                                                                                    service
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                    );
                                                                                }
                                                                            }
                                                                        )}
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {serviceTypes.length === 1 ? (
                                            <div
                                                className={
                                                    styles[`no-service-message`]
                                                }
                                            >
                                                Trenutno nema dostupne usluge.
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </>
                                )}
                            </div>
                        );
                    })
                )}
                <div
                    className={styles[`button-additional-questions-container`]}
                >
                    <ButtonAdditionalQuestions
                        selectedAttributes={selectedAttributes}
                        setInHelp={setInHelp}
                    >
                        Niste sigurni koju usugu izabrati? <br /> Kliknite
                        Ovdje!
                    </ButtonAdditionalQuestions>
                </div>
                <div className={styles.padding} />
            </div>
        </>
    );
}
